export default __webpack_public_path__ + "static/cable-hero-acde3095c01149304ef5eab932b28cdd.jpg";